var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modify-apply-block',{ref:"his_work_p",attrs:{"dataFileParm":{docName: '工作经历', isDoc: true},"data-type":"his_work","getEdit":_vm.getEdit,"saveEdit":_vm.saveEdit,"addEdit":_vm.addEdit,"form-parms-add":_vm.formParmsAdd,"block-name":"工作经历","ref-name":"his_work","getTitle":_vm.getTitle,"worker-id":_vm.workerId}})
}
var staticRenderFns = []

export { render, staticRenderFns }